import { Grid, IconButton } from "@mui/material";
import { Comment as CommentIcon } from "@mui/icons-material";

type ElementWithComments = {
  Comments?: string | null;
};

type Props<T extends ElementWithComments> = {
  data: T;
  setShowOpenModal:
    | ((
        show: boolean,
        data: T,
        position: { top: number; left: number },
      ) => void)
    | ((
        show: boolean,
        data?: T,
        position?: { top: number; left: number },
      ) => void);
};

export const CommentsColumn = <T extends ElementWithComments>({
  data,
  setShowOpenModal,
}: Props<T>) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    const position = {
      top: event.clientY,
      left: event.clientX,
    };
    setShowOpenModal(true, data, position);
  };

  if (!data.Comments) return null;

  return (
    <Grid container spacing={1} style={{ alignItems: "center" }}>
      {data?.Comments && (
        <Grid item md={12} xs={12}>
          <IconButton
            onClick={handleClick}
            color="primary"
            style={{
              textDecoration: "none",
              fontWeight: 500,
              fontSize: "12px",
              borderRadius: "3px",
              marginRight: 8,
            }}
          >
            <CommentIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};
